module.exports = __webpack_public_path__ + "img/hibob.e11e9ebb.svg";